import React from 'react';
import PropTypes from 'prop-types';

class Form extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        hasRequiredFields: PropTypes.bool,
    };

    static defaultProps = {
        hasRequiredFields: false,
    };

    render() {
        const { children, hasRequiredFields, ...props } = this.props;

        const requiredText = (
            <div className="formrow__legend">
                <span>* = Pflichtfeld</span>
            </div>
        );

        return (
            <form {...props}>
                {hasRequiredFields && requiredText}
                {children}
            </form>
        );
    }
}

export default Form;



// WEBPACK FOOTER //
// ./src/frontend/components/Form.jsx